module.exports = __webpack_public_path__ + "img/whitecloud.df961825.png";